export enum MarkType {
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  StrikeThrough = 'strikeThrough',
  Code = 'code',
  Spoiler = 'spoiler',
}

export enum BlockType {
  Paragraph = 'paragraph',
  Heading = 'heading',
  CodeLine = 'code-line',
  CodeBlock = 'code-block',
  QuoteLine = 'quote-line',
  BlockQuote = 'block-quote',
  ListItem = 'list-item',
  OrderedList = 'ordered-list',
  UnorderedList = 'unordered-list',
  Mention = 'mention',
  Emoticon = 'emoticon',
  Link = 'link',
  Command = 'command',
  PasteMarker = 'paste-marker',
}
